import React from 'react';
import { Control, useController } from 'react-hook-form';

import { IconTickFilled } from '@/assets/icons';
import { cn } from '@/lib/utils';

import { Input } from '../input';

interface InputFieldProps {
  name: string;
  control: Control<any>;
  label?: string;
  rules?: any;
  placeholder?: string;
  type?: string;
  className?: string;
  labelClassName?: string;
  fieldClassName?: string;
  disabled?: boolean;
}

export const InputField: React.FC<InputFieldProps> = ({
  name,
  control,
  label,
  rules,
  className,
  labelClassName,
  fieldClassName,
  placeholder = '',
  type = 'text',
  disabled = false,
}) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    rules,
    defaultValue: '',
  });
  const isValid = !error && field.value !== '';
  return (
    <div className={cn('sky-mark-bold-16 flex flex-col gap-2', className)}>
      {label && (
        <label htmlFor={name} className={cn('text-primary-midnight block', labelClassName)}>
          {label}
        </label>
      )}
      <div className="relative">
        <Input
          id={name}
          {...field}
          type={type}
          placeholder={placeholder}
          disabled={disabled}
          className={cn({ 'border-secondary-red': error }, fieldClassName)}
        />
        {isValid && (
          <IconTickFilled className="absolute right-3 top-1/2 size-5 -translate-y-1/2 transform" />
        )}
      </div>
      {error && <p className="sky-mark-regular-14 text-secondary-red">{error.message}</p>}
    </div>
  );
};
